import Vue from 'vue'
import Router from 'vue-router'
import ChallengePlay from '../views/GamePlay.vue'
import GameDashboard from '../views/GameDashboard.vue'
import CustomerDashboard from '../views/CustomerDashboard.vue'
import GameDemoer from '../views/GameDemoer.vue'
import GameRewards from '../views/GameRewards.vue'
import GameActivity from '../views/GameActivity.vue'
import EnterGameCode from '../views/EnterGameCode.vue'
import CheckNetworking from '../views/CheckNetworking.vue'
import GameTeamCreate from '../views/GameTeamCreate.vue'
import GameScoreboard from '../views/GameScoreboard.vue'
import ConfirmLogOut from '../views/ConfirmLogOut.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    { path: '/', redirect: '/game' },
    {
      path: '/check',
      name: 'check-networking',
      meta: { title: 'TAS - Network Test' },
      component: CheckNetworking
    },
    {
      path: '/dashboard/:dashboard_code',
      name: 'customer-dashboard',
      meta: { title: 'TAS - Dashboard' },
      component: CustomerDashboard,
      props: true
    },
    {
      path: '/demo/:game_type',
      name: 'demo-game',
      meta: { title: 'TAS - Demo' },
      component: GameDemoer,
      props: true
    },
    {
      path: '/game',
      name: 'enter-game-code',
      meta: { title: 'TAS - Enter Game Code' },
      component: EnterGameCode
    },
    {
      path: '/game/:code',
      name: 'create-team',
      meta: { title: 'TAS - Create Team' },
      component: GameTeamCreate,
      props: true
    },
    {
      path: '/game/:code/:dashboard_code/dashboard',
      name: 'game-dashboard',
      meta: { title: 'TAS - Dashboard' },
      component: GameDashboard,
      props: true
    },
    {
      path: '/game/:code/:team_id/rewards',
      name: 'game-rewards',
      meta: { title: 'TAS - Inventory' },
      component: GameRewards,
      props: true
    },
    {
      path: '/game/:code/:team_id/activity',
      name: 'game-activity',
      meta: { title: 'TAS - Live Feed' },
      component: GameActivity,
      props: true
    },
    {
      path: '/game/:code/:team_id/challenge/:challengeIndex',
      name: 'challenge-play',
      meta: { title: 'TAS - Play' },
      component: ChallengePlay,
      props: true
    },
    {
      path: '/game/:code/:team_id/scoreboard',
      name: 'game-scoreboard',
      component: GameScoreboard,
      props: true
    },
    {
      path: '/game/:code/:team_id/logout',
      name: 'confirm-logout',
      component: ConfirmLogOut,
      props: true
    }
  ]
})

const DEFAULT_TITLE = 'TAS'
router.afterEach(to => {
  // Use next tick to handle router history correctly
  // see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609
  Vue.nextTick(() => {
    document.title = to.meta.title || DEFAULT_TITLE
  })
})

export default router
